__turbopack_context__.v({
  "body-container": "course-landing-page-module-scss-module__WBF27W__body-container",
  "body-container-with-subs-diff": "course-landing-page-module-scss-module__WBF27W__body-container-with-subs-diff",
  "call-to-action": "course-landing-page-module-scss-module__WBF27W__call-to-action",
  "course-lede-with-subs-diff": "course-landing-page-module-scss-module__WBF27W__course-lede-with-subs-diff",
  "is-hidden": "course-landing-page-module-scss-module__WBF27W__is-hidden",
  "layout-container": "course-landing-page-module-scss-module__WBF27W__layout-container",
  "sidebar": "course-landing-page-module-scss-module__WBF27W__sidebar",
  "sidebar-container": "course-landing-page-module-scss-module__WBF27W__sidebar-container",
  "sidebar-preview-wrapper": "course-landing-page-module-scss-module__WBF27W__sidebar-preview-wrapper",
  "sticky-footer": "course-landing-page-module-scss-module__WBF27W__sticky-footer",
  "title-area": "course-landing-page-module-scss-module__WBF27W__title-area",
  "ud-color-scheme-dark": "course-landing-page-module-scss-module__WBF27W__ud-color-scheme-dark",
  "vernacular-cohort-banner": "course-landing-page-module-scss-module__WBF27W__vernacular-cohort-banner",
});
